import { Flex } from '@chakra-ui/react';

import { chakraStyled } from 'utils';

export const Container = chakraStyled(Flex, {
  flex: 1,
  direction: 'column',
  mb: '100px',
});
